"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefundDecisionRequestDto = exports.CreateRefundRequestRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class CreateRefundRequestRequestDto {}
exports.CreateRefundRequestRequestDto = CreateRefundRequestRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Why the user wants a refund (≤ 1000 chars). Opens the feedback topic where the refund is discussed.'
}), __metadata("design:type", String)], CreateRefundRequestRequestDto.prototype, "reason", void 0);
class RefundDecisionRequestDto {}
exports.RefundDecisionRequestDto = RefundDecisionRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Message posted to the user in the feedback topic (≤ 1000 chars). A default text is used when empty.'
}), __metadata("design:type", String)], RefundDecisionRequestDto.prototype, "note", void 0);
//# sourceMappingURL=RefundRequest.dto.js.map